module.exports = __webpack_public_path__ + "img/phone.49247415.svg";